// extracted by mini-css-extract-plugin
export default {"infinitheism":"ColorizeMahatriaInfinitheism_infinitheism__A5lxk","mahatria":"ColorizeMahatriaInfinitheism_mahatria__Q7m4i"};